// extracted by mini-css-extract-plugin
export var fadeIn = "_32-0";